
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSources03 as ObiSources03Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-sources-03.js';
 
 
 

 
 export const ObiSources03 = createComponent({
   react: React,
   tagName: 'obi-sources-03',
   elementClass: ObiSources03Element,
   events: {
     
   }
  });
 
 